<script setup lang="ts">
import { StaticProductData } from '~/lib/models/async-data'
import { McdViewError } from '~/lib/models/errors'
import { GTMContentGroup } from '~/lib/models/gtm'

definePageMeta({
  alias: ['/cardapio/:categorySlug/:productSlug'],
})

const route = useRoute()

const { categorySlug, productSlug } = getRouteParams(route.params, ['categorySlug', 'productSlug'])
const { loadProductData } = useMenu()
const errorView = useErrorView()
const { trackPageView } = useGTM()

const { data, error } = await useWrapperKeyAsyncData<StaticProductData, McdViewError>(
  `static-product-data-${categorySlug}-${productSlug}`,
  () => loadProductData(categorySlug, productSlug)
)

if (error.value) {
  // I am receiving here an H3Error not a McdViewError, maybe we can try with throw createError and built in nuxt error handling
  // for now is a workaround that works
  const cause = error.value.cause instanceof McdViewError ? error.value.cause : undefined
  errorView.value = cause || error.value
}

onMounted(() => {
  if (data.value?.product) {
    trackPageView({
      cg: GTMContentGroup.primary.OUR_MENU,
      cg2: GTMContentGroup.secondary.ITEM_DETAIL,
      cg3: productSlug,
    })
  }
})

useHeadSafe({
  meta: [
    {
      property: 'og:image',
      content: data.value?.product.image || '/images/icons/placeholder.svg',
    },
    {
      property: 'og:image:alt',
      content: data?.value?.product?.name,
    },
  ],
})
</script>
<template>
  <LazyErrorView v-if="error" :error="errorView || error" />
  <main v-else-if="data && data.product">
    <ProductView :product-detail="data.product" :category-name="data.categoryName" />
  </main>
</template>
